import { CommandBar } from "@fluentui/react";
import { Badge, Descriptions, Divider, Drawer, Skeleton } from "antd";
import EbendoDailyProductionStore from "../../store/ebendodailyproductionstore";
import { observer } from "mobx-react-lite";
import React, { createContext, useContext } from "react";
import { Printer } from "react-feather";
import RequestStore from "../store/requeststore";
import moment from "moment";
import { Printd } from 'printd'
import formatNumber from "accounting-js/lib/formatNumber";
import renderHTML from "react-render-html";
const requestStoreCtx = createContext(RequestStore);
const EbendoStoreCtx = createContext(EbendoDailyProductionStore);
export const EbendoDailyProductionDetail = observer(() => {
  const ebendoDailyProductionStore = useContext(EbendoStoreCtx);
  const requestStore = useContext(requestStoreCtx);
  return (
    <Drawer
      title={`Ebendo Daily Production Details`}
      placement="right"
      width={"60%"}
      closable={true}
      destroyOnClose={true}
      onClose={() => {
        requestStore.showEbendoProductionDetailDialog = false;
      }}
      visible={requestStore.showEbendoProductionDetailDialog}
    >
      {ebendoDailyProductionStore.isLoadingDailyProd ? (
        <>
          <Skeleton active />
          <Skeleton active />
          <Skeleton active />
          <Skeleton active />
        </>
      ) : (
        <>
         <div id="printPane">
          <Badge.Ribbon
            text={ebendoDailyProductionStore.initFormaData.status}
            placement="start"
            color={
              ebendoDailyProductionStore.initFormaData.approvalStatus === 1
                ? "gold"
                : ebendoDailyProductionStore.initFormaData.approvalStatus === 2
                ? "#87d068"
                : ebendoDailyProductionStore.initFormaData.approvalStatus === 3
                ? "#f50"
                : "#d9d9d9"
            }
          >
            <CommandBar
              farItems={[
                {
                  key: "print",
                  text: "Print",
                  onRenderIcon: () => <Printer className="qicon" />,
                  onClick:()=>{
                    const d=new Printd();
                    d.print( document.getElementById('printPane'), [] )
                  }
                },
              ]}
            />
          </Badge.Ribbon>
          <Divider>{`${
            ebendoDailyProductionStore.IsEquityProduction === 0
              ? "EBENDO JV GROSS"
              : "QUAIBO EQUITY SHARE"
          } PRODUCTION FIGURES @ ${moment(
            ebendoDailyProductionStore.initFormaData.productionDate
          ).format(" dddd, Do MMMM YYYY")}`}</Divider>
          <Descriptions
            title={"Production Figures"}
            size={"small"}
            bordered
            labelStyle={{ fontWeight: "bold" }}
          >
            <Descriptions.Item label="Bulk Liquid Produced (BLPD)">
              {formatNumber(ebendoDailyProductionStore.initFormaData.blpd, {
                precision: 2,
                thousand: ",",
              })}
            </Descriptions.Item>
            <Descriptions.Item label="Net Oil Production (bopd) ">
              {formatNumber(ebendoDailyProductionStore.initFormaData.oil, {
                precision: 2,
                thousand: ",",
              })}
            </Descriptions.Item>
            <Descriptions.Item label="Station Water Production (bwpd)">
              {formatNumber(ebendoDailyProductionStore.initFormaData.water, {
                precision: 2,
                thousand: ",",
              })}
            </Descriptions.Item>

            <Descriptions.Item label="Condensate from Gas Plant (bopd)">
              {formatNumber(
                ebendoDailyProductionStore.initFormaData.condensate,
                {
                  precision: 2,
                  thousand: ",",
                }
              )}
            </Descriptions.Item>

            <Descriptions.Item label="Gas (Mmscfd)">
              {formatNumber(ebendoDailyProductionStore.initFormaData.gas, {
                precision: 2,
                thousand: ",",
              })}
            </Descriptions.Item>
            <Descriptions.Item label="Fuel Gas (Mmscfd)">
              {formatNumber(ebendoDailyProductionStore.initFormaData.fuelGas, {
                precision: 2,
                thousand: ",",
              })}
            </Descriptions.Item>

            <Descriptions.Item label="Total  Flared (Mmscfd)">
              {formatNumber(ebendoDailyProductionStore.initFormaData.flareGas, {
                precision: 2,
                thousand: ",",
              })}
            </Descriptions.Item>
          </Descriptions>
          <Descriptions
            title={<div>Evacuation Figures</div>}
            size={"small"}
            bordered
            labelStyle={{ fontWeight: "bold" }}
          >
            <Descriptions.Item label="Crude injection to GGF(bbls)">
              {formatNumber(
                ebendoDailyProductionStore.initFormaData.crudeInjectionGGF,
                {
                  precision: 2,
                  thousand: ",",
                }
              )}
            </Descriptions.Item>
            <Descriptions.Item label="Gas Supplied to Gas plant(Mmscfd)">
              {formatNumber(
                ebendoDailyProductionStore.initFormaData.gasSuppliedToGasPlant,
                {
                  precision: 2,
                  thousand: ",",
                }
              )}
            </Descriptions.Item>
            <Descriptions.Item label="Crude Exported through Ase River">
              {formatNumber(
                ebendoDailyProductionStore.initFormaData.aseRiverExport,
                {
                  precision: 2,
                  thousand: ",",
                }
              )}
            </Descriptions.Item>

            <Descriptions.Item label="Crude Exported through Forcados">
              {formatNumber(
                ebendoDailyProductionStore.initFormaData.forcadosExport,
                {
                  precision: 2,
                  thousand: ",",
                }
              )}
            </Descriptions.Item>
            <Descriptions.Item label="Evacuated Condensate(bopd)">
              {formatNumber(
                ebendoDailyProductionStore.initFormaData.evacuatedCondensate,
                {
                  precision: 2,
                  thousand: ",",
                }
              )}
            </Descriptions.Item>
            <Descriptions.Item label="Ase River Daily Uptime (hrs)">
              {ebendoDailyProductionStore.initFormaData.aseRiverUptime}
            </Descriptions.Item>
            <Descriptions.Item label="Forcados  Daily Uptime(hrs)">
              {ebendoDailyProductionStore.initFormaData.forcadosUptime}
            </Descriptions.Item>
          </Descriptions>

          <Descriptions
            title={<div>Other Station Figures</div>}
            size={"small"}
            bordered
            labelStyle={{ fontWeight: "bold" }}
          >
            <Descriptions.Item label="Station Downtime(hrs)">
              {ebendoDailyProductionStore.initFormaData.stationDownHrs}
            </Descriptions.Item>
            <Descriptions.Item label="Station API (@60 degF)">
              {ebendoDailyProductionStore.initFormaData.stationAPI}
            </Descriptions.Item>

            <Descriptions.Item label="Station BS&W (%)">
              {ebendoDailyProductionStore.initFormaData.bsw}
            </Descriptions.Item>
          </Descriptions>

          <Descriptions
            title="PRODUCTION REMARKS"
            size={"small"}
            bordered
            labelStyle={{ fontWeight: "bold" }}
          >
            <Descriptions.Item label="EBENDO DAILY  PRODUCTION REMARKS">
              {ebendoDailyProductionStore.initFormaData.remarks &&
                renderHTML(ebendoDailyProductionStore.initFormaData.remarks)}
            </Descriptions.Item>
          </Descriptions>

          {ebendoDailyProductionStore.initFormaData.approvalStatus === 2 && (
            <Descriptions
              title="PRODUCTION APPROVAL "
              size={"small"}
              bordered
              labelStyle={{ fontWeight: "bold" }}
            >
              <Descriptions.Item label="Approved On">
                {moment(
                  ebendoDailyProductionStore.initFormaData.approvedDate
                ).format("LLLL")}
              </Descriptions.Item>
              <Descriptions.Item label="Approver">
                {ebendoDailyProductionStore.initFormaData.approver}
              </Descriptions.Item>
              <Descriptions.Item label="Approver Remarks">
                {ebendoDailyProductionStore.initFormaData.approverComment}
              </Descriptions.Item>
            </Descriptions>
          )}
          </div>
        </>
      )}
    </Drawer>
  );
});

